/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 是否有审核权限
 */
let EnumAudit = {
    Yes             : new EnumItem('是', 1),
    No              : new EnumItem('否', 2),
    ...enumMixn
}
export default EnumAudit
